import React, { useRef, useState } from 'react';

const ImportButton = ({ onImport, className }) => {
  const fileInputRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
      // Reset the input value to allow importing the same file again
      fileInputRef.current.value = '';
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setShowOptions(true); // Show the overlay to choose "Add" or "Replace"
    }
  };

  const handleImportOption = (option) => {
    // console.log("selectedFile", selectedFile);
    console.log("option", option);
    if (selectedFile) {
      onImport(selectedFile, option); // Pass the file and the option ("add" or "replace") to onImport
    }
    setShowOptions(false); // Hide the overlay
    setSelectedFile(null); // Reset the selected file
  };

  return (
    <>
      <button
        className={className}
        onClick={handleClick}
      >
        Import Flow
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />

      {/* Overlay for "Add" or "Replace" */}
      {showOptions && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div className="flex flex-row text-center">
            <button
              onClick={() => handleImportOption('add')}
              className='w-80 h-80 cursor-pointer bg-[#25005C] hover:bg-[#3F007F] active:bg-[#4F008F] rounded-md text-2xl transition-colors duration-200 border border-purple-700'
            >
              Add
            </button>
            <button
              onClick={() => handleImportOption('replace')}
              className='ml-20 w-80 h-80 cursor-pointer bg-[#25005C] hover:bg-[#3F007F] active:bg-[#4F008F] rounded-md text-2xl transition-colors duration-200 border border-purple-700'
            >
              Replace
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ImportButton;



// import React, { useRef } from 'react';

// const ImportButton = ({ onImport, className }) => {
//   const fileInputRef = useRef(null);
  
//   const handleClick = () => {
//     if (fileInputRef.current) {
//       fileInputRef.current.click();
//       // Reset the input value to allow importing the same file again
//       fileInputRef.current.value = '';
//     }
//   };
  
//   const handleFileChange = (event) => {
//     const file = event.target.files?.[0];
//     if (file) {
//       onImport(file);
//     }
//   };
  
//   return (
//     <>
//       <button
//         className={className}
//         onClick={handleClick}
//       >
//         Import Flow
//       </button>
//       <input
//         ref={fileInputRef}
//         type="file"
//         accept=".json"
//         onChange={handleFileChange}
//         style={{ display: 'none' }}
//       />
//     </>
//   );
// };

// export default ImportButton;